export default {
  label: 'Respondidos',
  items: {
    placeholder: 'Todos',
    replied: 'Somente Respondidos',
    unanswered: 'Somente Não Respondidos',
  },
};
